import * as Yup from 'yup';

export const EditProfileSchema = Yup.object().shape({
  email: Yup.string()
    .email('_ERR_EMAIL_REQUIRED')
    .required('_PARAMETER_IS_REQUEIRED'),
  mobile: Yup.number('_ERR_MOBILE_REQUIRED').required('_PARAMETER_IS_REQUEIRED')
});
